import OnboardingDetail from '@/pages/OnboardingDetail';

export default function MobileOnboardingDetailScreen() {
  return <OnboardingDetail />;
}

